import { render } from "./AccountSerialNumberLoginView.vue?vue&type=template&id=6775a63a&scoped=true"
import script from "./AccountSerialNumberLoginView.vue?vue&type=script&lang=js"
export * from "./AccountSerialNumberLoginView.vue?vue&type=script&lang=js"

import "./AccountSerialNumberLoginView.vue?vue&type=style&index=0&id=6775a63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6775a63a"]])

export default __exports__